import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#6e3bff',
    },
    secondary: {
      main: '#ff3bff',
    },
    background: {
      default: '#0f051d',
      paper: '#1a0933',
    },
    text: {
      primary: '#ffffff',
      secondary: '#b8b8b8',
    },
  },
  typography: {
    fontFamily: '"Space Mono", monospace, "Roboto", "Helvetica", "Arial", sans-serif',
  },
  shape: {
    borderRadius: 12,
  },
});